import React, { useEffect, useState } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import PropTypes from 'prop-types';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { searchEvent } from '../events';

const CustomSearchInput = styled(TextInput, {
  '&.abyss-icon-material': {
    fill: '$interactive1',
  },
  '&.abyss-icon': {
    fill: '$interactive1',
  },
});

export const StandaloneSearchBox = ({
  controller,
  setIsFacetSelected,
  setSelectedFacets,
}) => {
  const [searchState, setSearchState] = useState(controller.state);
  const router = useRouter();

  useEffect(() => {
    if (controller && typeof controller.subscribe === 'function') {
      const unsubscribe = controller.subscribe(() =>
        setSearchState(controller.state)
      );
      return () => {
        if (typeof unsubscribe === 'function') unsubscribe();
      };
    }
  }, [controller]);

  const handleChange = (e) => {
    controller.updateText(e.target.value);
  };
  const handleSearch = () => {
    if (!searchState.value || searchState.value.includes('%')) {
      controller.updateText('');
      return;
    }
    // on new seach, clear all facets
    setIsFacetSelected(false);
    setSelectedFacets([]);
    event.setData(
      searchEvent({
        searchEventTrigger: 'searchboxSubmit',
        searchTerm: searchState.value,
      })
    );
    const encodedSearchTerm = encodeURIComponent(searchState.value);
    router.navigate(`/app-search/${encodedSearchTerm}`);
  };

  const handleClear = () => {
    controller.clear();
  };
  return (
    <div>
      <CustomSearchInput
        data-testid='coveo-search-page-input'
        type='search'
        label='Search'
        placeholder='Search'
        value={searchState && searchState.value}
        onChange={(e) => handleChange(e)}
        onClickSearch={handleSearch}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        isClearable
        onClear={() => handleClear()}
      />
      {/* FUTURE TODO: Add suggested searches based on text input below via controller.state.suggestions and controller.selectSuggestion(suggestion) */}
    </div>
  );
};

StandaloneSearchBox.propTypes = {
  controller: PropTypes.shape({
    state: PropTypes.shape({
      value: PropTypes.string,
      isLoading: PropTypes.bool,
      isLoadingSuggestions: PropTypes.bool,
      suggestions: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    subscribe: PropTypes.func.isRequired,
    updateText: PropTypes.func.isRequired,
    selectSuggestion: PropTypes.func.isRequired,
    showSuggestions: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
  }),
  setIsFacetSelected: PropTypes.func.isRequired,
  setSelectedFacets: PropTypes.func.isRequired,
};

StandaloneSearchBox.defaultProps = {
  controller: {
    state: {
      value: '',
      isLoading: false,
      isLoadingSuggestions: false,
      suggestions: [],
    },
  },
};
